import script from "./QRCode.vue?vue&type=script&setup=true&lang=js"
export * from "./QRCode.vue?vue&type=script&setup=true&lang=js"

import "./QRCode.vue?vue&type=style&index=0&id=61af94ce&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61af94ce"]])

export default __exports__